// extracted by mini-css-extract-plugin
export default {"LoadError":"bfc_a bhp_qs bhp_a bhp_w bhp_j bhp_q","LoadError__icon":"bfc_b bhp_vl bhp_fm bhp_sw","LoadError__message":"bfc_c bhp_fm bhp_tr"};